import { memo, useMemo } from 'react';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';

import { OfferStatusFilterValue } from '../../OfferFilters.types';

interface IStatusFilterProps {
  selected: OfferStatusFilterValue[];
  onSelectionChange: (values: OfferStatusFilterValue[]) => void;
}

const STATUS_OPTIONS: FilterOption[] = [
  { label: 'Active', value: OfferStatusFilterValue.ACTIVE },
  { label: 'Inactive', value: OfferStatusFilterValue.INACTIVE }
];

export const StatusFilter = memo(({ selected, onSelectionChange }: IStatusFilterProps) => {
  const selectedValues = useMemo(() => selected.map(String), [selected]);

  return (
    <FilterPopover
      label="Status"
      filterType={FilterType.CHECKLIST}
      options={STATUS_OPTIONS}
      selectedItems={selectedValues}
      onSelectionChange={onSelectionChange as (items: string[]) => void}
      dataTestId="offers-status-filter"
      popoverHeight="auto"
    />
  );
});

StatusFilter.displayName = 'StatusFilter';
